const urlBase = `${process.env.REACT_APP_API_PROTOCOL}://${
  process.env.REACT_APP_API_HOST
}${
  process.env.REACT_APP_API_PORT ? `:${process.env.REACT_APP_API_PORT}` : ""
}/api/`;

/** AUTH **/
export const urlGetLoginItemTemp = `${urlBase}v1/items/login`;

export const urlRefreshToken = `${urlBase}v1/user/refresh-token`;
export const urlLogout = `${urlBase}v1/user/logout`;
export const urlGetProfile = `${urlBase}v1/user-s/profile`;
export const urlUserSecured = `${urlBase}v1/user-s`;
export const urlSpeakersSecured = `${urlBase}v1/user-s/speakers`;

export const urlPreRegisterEmployee = `${urlBase}v1/employeeRequest-s/preRegister`;
export const urlDataUser = `${urlBase}v1/dataUser-s`;

export const urlProviderSecured = `${urlBase}v1/provider-s`;
export const urlProviderFilterSecured = `${urlBase}v1/provider-s/filter`;

export const urlRequestProviderSecured = `${urlBase}v1/requestprovider-s`;
export const urlRequestProviderFilterSecured = `${urlBase}v1/requestprovider-s/filter`;
export const urlRequestProviderAsNotRequiredSecured = `${urlBase}v1/requestprovider-s/homologateNotRequired`;
export const urlMyRequestProviderFilterSecured = `${urlBase}v1/requestprovider-s/my/providerProcess`;
export const urlRequestProviderCompleteData = `${urlBase}v1/requestprovider-s/complete`;

export const urlCompanySecured = `${urlBase}v1/company-s`;
export const urlCompanyAllSecured = `${urlBase}v1/company-s/all`;

export const urlUploadSecured = `${urlBase}v1/upload-s`;

export const urlProviderLogin = `${urlBase}v1/provider/login`;
export const urlAuthChangePass = `${urlBase}v1/provider-s/changePassword`;
export const urlAuthChangePass2 = `${urlBase}v1/provider/changePassword`;
export const urlNewTemporalPass = `${urlBase}v1/provider/newTemporalPass`;

export const urlProductionDataSecured = `${urlBase}v1/productionData-s`;

export const urlRequestHistorySecured = `${urlBase}v1/requestHistory-s`;

export const urlFormSecured = `${urlBase}v1/forms-s`;
export const urlForm = `${urlBase}v1/forms`;
export const urlFormAllSecured = `${urlBase}v1/forms-s/all`;

export const urlRequestFormProviderSecured = `${urlBase}v1/requestFormProviders-s`;
export const urlRequestFormProvider = `${urlBase}v1/requestFormProviders`;
export const urlSaveRequestFormProviderSecured = `${urlBase}v1/requestFormProviders-s/save`;

export const urlAttendanceSecured = `${urlBase}v1/attendance-s`;
export const urlAttendanceAllSecured = `${urlBase}v1/attendance-s/filter`;
export const urlCourseSecured = `${urlBase}v1/course-s`;
export const urlCourseAllSecured = `${urlBase}v1/course-s/filter`;
export const urlMeetingSecured = `${urlBase}v1/meeting-s`;
export const urlMeetingAllSecured = `${urlBase}v1/meeting-s/filter`;
export const urlSessionSecured = `${urlBase}v1/session-s`;
export const urlSessionCompleteSecured = `${urlBase}v1/session-s/complete`;
export const urlSessionAllSecured = `${urlBase}v1/session-s/filter`;
export const urlSessionDocumentSecured = `${urlBase}v1/session-s/generateDocument`;
export const urlExportSessionSecured = `${urlBase}v1/session-s/export`;

export const urlCourseAllListSecured = `${urlBase}v1/course-s/list`;
export const urlMeetingAllAllSecured = `${urlBase}v1/meeting-s/all`;
export const urlExportMeetingSecured = `${urlBase}v1/meeting-s/export`;

export const urlPersonsSecured = `${urlBase}v1/person-s`;
export const urlFarmsSecured = `${urlBase}v1/centers-s/centers`;

export const urlSynchronizeViewersSecured = `${urlBase}v1/viewers-s/syncro`;
export const urlViewerSecured = `${urlBase}v1/viewers-s`;

export const urlSynchronizeFarmsSecured = `${urlBase}v1/centers-s/FarmSyncro`;

export const urlCenterAllSecured = `${urlBase}v1/centers-s`;
export const urlAllCentersSecured = `${urlBase}v1/centers-s/all`;

export const urlAllSettingsSecured = `${urlBase}v1/settings-s/all`;
